// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-0fcb1d44]{transition:all .7s;transition-delay:.2s}.fade-leave-active[data-v-0fcb1d44]{transition:all 0s}.fade-enter[data-v-0fcb1d44],.fade-leave-active[data-v-0fcb1d44]{height:0;opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
